const PALLET_ROUNDED_GAZ_CATEGORY_NAMES = new Set([
  "брусчатка",
  "брусчатка и тротуарная плитка",
  "плитка тротуарная",
  "газонная решетка",
  "лоток водоотводный жби",
  "лоток водоотводный тротуарный",
  "газобетон вкблок",
  "газобетон bonolit",
  "газобетон могилевский кси",
  "газобетон могилевский газосиликат",
  "газобетон лср",
  "газобетон istkult",
  "газобетон istkultt",
  "газобетон leitberg",
  "газобетон иваново",
]);

const normalizeCategoryName = (value) =>
  String(value || "")
    .trim()
    .toLowerCase()
    .replace(/ё/g, "е")
    .replace(/\s+/g, " ");

export const shouldRoundGazQuantity = (...values) =>
  values.some((value) => PALLET_ROUNDED_GAZ_CATEGORY_NAMES.has(normalizeCategoryName(value)));

const STRICT_GAZ_PALLET_UNITS_CATEGORY_NAMES = new Set([
  "газобетон вкблок",
  "газобетон bonolit",
  "газобетон могилевский кси",
  "газобетон могилевский газосиликат",
  "газобетон лср",
  "газобетон istkult",
  "газобетон istkultt",
  "газобетон leitberg",
  "газобетон иваново",
]);

export const shouldUseStrictGazPalletUnits = (...values) =>
  values.some((value) => STRICT_GAZ_PALLET_UNITS_CATEGORY_NAMES.has(normalizeCategoryName(value)));

const PIECEWISE_GAZ_CATEGORY_NAMES = new Set([
  "u-блок bonolit",
  "бордюр",
  "бордюр дорожный",
]);

export const shouldCountGazByPiece = (...values) =>
  values.some((value) => PIECEWISE_GAZ_CATEGORY_NAMES.has(normalizeCategoryName(value)));
